{
  "REPORT": {
    "HEADER": "Разговори",
    "LOADING_CHART": "Loading chart data...",
    "NO_ENOUGH_DATA": "We've not received enough data points to generate report, Please try again later.",
    "DOWNLOAD_AGENT_REPORTS": "Download agent reports",
    "DATA_FETCHING_FAILED": "Failed to fetch data, please try again later.",
    "SUMMARY_FETCHING_FAILED": "Failed to fetch summary, please try again later.",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Разговори",
        "DESC": "( Total )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Incoming Messages",
        "DESC": "( Total )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Outgoing Messages",
        "DESC": "( Total )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "First Response Time",
        "DESC": "( Avg )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "First Response Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Resolution Time",
        "DESC": "( Avg )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "Resolution Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Resolution Count",
        "DESC": "( Total )"
      },
      "BOT_RESOLUTION_COUNT": {
        "NAME": "Resolution Count",
        "DESC": "( Total )"
      },
      "BOT_HANDOFF_COUNT": {
        "NAME": "Handoff Count",
        "DESC": "( Total )"
      },
      "REPLY_TIME": {
        "NAME": "Customer waiting time",
        "TOOLTIP_TEXT": "Waiting time is {metricValue} (based on {conversationCount} replies)",
        "DESC": ""
      }
    },
    "DATE_RANGE_OPTIONS": {
      "TODAY": "Днес",
      "YESTERDAY": "Вчера",
      "LAST_7_DAYS": "Last 7 days",
      "LAST_30_DAYS": "Last 30 days",
      "THIS_MONTH": "Този месец",
      "LAST_MONTH": "Миналия месец",
      "LAST_3_MONTHS": "Last 3 months",
      "LAST_6_MONTHS": "Last 6 months",
      "LAST_YEAR": "Last year",
      "CUSTOM_DATE_RANGE": "Custom date range"
    },
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Apply",
      "PLACEHOLDER": "Select date range"
    },
    "GROUP_BY_FILTER_DROPDOWN_LABEL": "Group By",
    "DURATION_FILTER_LABEL": "Duration",
    "GROUPING_OPTIONS": {
      "DAY": "Day",
      "WEEK": "Week",
      "MONTH": "Month",
      "YEAR": "Month"
    },
    "GROUP_BY_DAY_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Day"
      }
    ],
    "GROUP_BY_WEEK_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Day"
      },
      {
        "id": 2,
        "groupBy": "Week"
      }
    ],
    "GROUP_BY_MONTH_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Day"
      },
      {
        "id": 2,
        "groupBy": "Week"
      },
      {
        "id": 3,
        "groupBy": "Month"
      }
    ],
    "GROUP_BY_YEAR_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Day"
      },
      {
        "id": 2,
        "groupBy": "Week"
      },
      {
        "id": 3,
        "groupBy": "Month"
      }
    ],
    "BUSINESS_HOURS": "Business Hours",
    "FILTER_ACTIONS": {
      "CLEAR_FILTER": "Clear filter",
      "EMPTY_LIST": "Няма намерени резултати"
    },
    "DRILLDOWN": {
      "RESULT_COUNT_CONVERSATION": "Разговори: {count}",
      "RESULT_COUNT_MESSAGE": "Съобщения: {count}",
      "EMPTY": "Няма намерени записи за тази колона.",
      "ERROR": "Записите не можаха да бъдат заредени. Моля, опитайте отново.",
      "LOAD_MORE": "Зареди още",
      "PREVIOUS_BUCKET": "Предишна колона",
      "NEXT_BUCKET": "Следваща колона",
      "UNKNOWN_CONTACT": "Неизвестен контакт",
      "UNKNOWN_INBOX": "Неизвестна входяща кутия",
      "UNASSIGNED_AGENT": "Неразпределен",
      "NO_MESSAGE_CONTENT": "Няма съдържание на съобщението",
      "MESSAGE_CREATED_AT": "Съобщението е създадено на {time}",
      "EVENT_OCCURRED_AT": "Събитието е настъпило на {time}",
      "INCOMING_MESSAGE": "Входящо съобщение",
      "OUTGOING_MESSAGE": "Изходящо съобщение",
      "VIEW_ALL": "Преглед в разговорите",
      "VIEW_ALL_LIMIT": "В списъка с разговори се отварят само колони с най-много {limit} разговора.",
      "HIDDEN_COUNT": "Не са показани, защото не сте член на тяхната входяща кутия: {count}"
    },
    "PAGINATION": {
      "RESULTS": "Showing {start} to {end} of {total} results",
      "PER_PAGE_TEMPLATE": "{size} / page"
    }
  },
  "AGENT_REPORTS": {
    "HEADER": "Agents Overview",
    "DESCRIPTION": "Easily track agent performance with key metrics such as conversations, response times, resolution times, and resolved cases. Click an agent’s name to learn more.",
    "LOADING_CHART": "Loading chart data...",
    "NO_ENOUGH_DATA": "We've not received enough data points to generate report, Please try again later.",
    "DOWNLOAD_AGENT_REPORTS": "Download agent reports",
    "FILTER_DROPDOWN_LABEL": "Select Agent",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Разговори",
        "DESC": "( Total )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Incoming Messages",
        "DESC": "( Total )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Outgoing Messages",
        "DESC": "( Total )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "First Response Time",
        "DESC": "( Avg )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "First Response Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Resolution Time",
        "DESC": "( Avg )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "Resolution Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Resolution Count",
        "DESC": "( Total )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Last 7 days"
      },
      {
        "id": 1,
        "name": "Last 30 days"
      },
      {
        "id": 2,
        "name": "Last 3 months"
      },
      {
        "id": 3,
        "name": "Last 6 months"
      },
      {
        "id": 4,
        "name": "Last year"
      },
      {
        "id": 5,
        "name": "Custom date range"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Apply",
      "PLACEHOLDER": "Select date range"
    }
  },
  "LABEL_REPORTS": {
    "HEADER": "Labels Overview",
    "DESCRIPTION": "Проследявайте представянето на етикетите с ключови показатели, включително разговори, време за отговор, време за разрешаване и разрешени случаи.",
    "LOADING_CHART": "Loading chart data...",
    "NO_ENOUGH_DATA": "We've not received enough data points to generate report, Please try again later.",
    "DOWNLOAD_LABEL_REPORTS": "Download label reports",
    "FILTER_DROPDOWN_LABEL": "Select Label",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Разговори",
        "DESC": "( Total )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Incoming Messages",
        "DESC": "( Total )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Outgoing Messages",
        "DESC": "( Total )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "First Response Time",
        "DESC": "( Avg )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "First Response Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Resolution Time",
        "DESC": "( Avg )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "Resolution Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Resolution Count",
        "DESC": "( Total )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Last 7 days"
      },
      {
        "id": 1,
        "name": "Last 30 days"
      },
      {
        "id": 2,
        "name": "Last 3 months"
      },
      {
        "id": 3,
        "name": "Last 6 months"
      },
      {
        "id": 4,
        "name": "Last year"
      },
      {
        "id": 5,
        "name": "Custom date range"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Apply",
      "PLACEHOLDER": "Select date range"
    }
  },
  "INBOX_REPORTS": {
    "HEADER": "Inbox Overview",
    "DESCRIPTION": "Quickly view your inbox performance with key metrics like conversations, response times, resolution times, and resolved cases—all in one place. Click an inbox name for more details.",
    "LOADING_CHART": "Loading chart data...",
    "NO_ENOUGH_DATA": "We've not received enough data points to generate report, Please try again later.",
    "DOWNLOAD_INBOX_REPORTS": "Download inbox reports",
    "FILTER_DROPDOWN_LABEL": "Select Inbox",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Разговори",
        "DESC": "( Total )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Incoming Messages",
        "DESC": "( Total )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Outgoing Messages",
        "DESC": "( Total )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "First Response Time",
        "DESC": "( Avg )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "First Response Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Resolution Time",
        "DESC": "( Avg )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "Resolution Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Resolution Count",
        "DESC": "( Total )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Last 7 days"
      },
      {
        "id": 1,
        "name": "Last 30 days"
      },
      {
        "id": 2,
        "name": "Last 3 months"
      },
      {
        "id": 3,
        "name": "Last 6 months"
      },
      {
        "id": 4,
        "name": "Last year"
      },
      {
        "id": 5,
        "name": "Custom date range"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Apply",
      "PLACEHOLDER": "Select date range"
    }
  },
  "TEAM_REPORTS": {
    "HEADER": "Team Overview",
    "DESCRIPTION": "Get a snapshot of your team’s performance with essential metrics, including conversations, response times, resolution times, and resolved cases. Click a team name for more details.",
    "LOADING_CHART": "Loading chart data...",
    "NO_ENOUGH_DATA": "We've not received enough data points to generate report, Please try again later.",
    "DOWNLOAD_TEAM_REPORTS": "Download team reports",
    "FILTER_DROPDOWN_LABEL": "Select Team",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Разговори",
        "DESC": "( Total )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Incoming Messages",
        "DESC": "( Total )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Outgoing Messages",
        "DESC": "( Total )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "First Response Time",
        "DESC": "( Avg )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "First Response Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Resolution Time",
        "DESC": "( Avg )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "Resolution Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Resolution Count",
        "DESC": "( Total )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Last 7 days"
      },
      {
        "id": 1,
        "name": "Last 30 days"
      },
      {
        "id": 2,
        "name": "Last 3 months"
      },
      {
        "id": 3,
        "name": "Last 6 months"
      },
      {
        "id": 4,
        "name": "Last year"
      },
      {
        "id": 5,
        "name": "Custom date range"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Apply",
      "PLACEHOLDER": "Select date range"
    }
  },
  "CSAT_REPORTS": {
    "HEADER": "CSAT Reports",
    "NO_RECORDS": "There are no CSAT survey responses available.",
    "DOWNLOAD": "Download CSAT Reports",
    "DOWNLOAD_FAILED": "Failed to download CSAT Reports",
    "FILTERS": {
      "AGENTS": {
        "PLACEHOLDER": "Choose Agents"
      }
    },
    "TABLE": {
      "HEADER": {
        "CONTACT_NAME": "Contact",
        "AGENT_NAME": "Assigned agent",
        "RATING": "Rating",
        "FEEDBACK_TEXT": "Feedback comment"
      }
    },
    "METRIC": {
      "TOTAL_RESPONSES": {
        "LABEL": "Total responses",
        "TOOLTIP": "Total number of responses collected"
      },
      "SATISFACTION_SCORE": {
        "LABEL": "Satisfaction score",
        "TOOLTIP": "Total number of positive responses / Total number of responses * 100"
      },
      "RESPONSE_RATE": {
        "LABEL": "Response rate",
        "TOOLTIP": "Total number of responses / Total number of CSAT survey messages sent * 100"
      }
    }
  },
  "BOT_REPORTS": {
    "HEADER": "Bot Reports",
    "METRIC": {
      "CONVERSATION_COUNT": {
        "LABEL": "Брой разговори",
        "TOOLTIP": "Общ брой разговори със съобщения от бот"
      },
      "OUTGOING_COUNT": {
        "LABEL": "Брой отговори",
        "TOOLTIP": "Общ брой изходящи съобщения"
      },
      "MESSAGE_COUNT": {
        "LABEL": "Брой AI отговори",
        "TOOLTIP": "Общ брой отговори, изпратени от бота"
      },
      "COPILOT_COUNT": {
        "LABEL": "Брой подготвени отговори",
        "TOOLTIP": "Общ брой copilot предложения, подготвени от бота за операторите"
      },
      "SUCCESS_RATE": {
        "LABEL": "Разрешени от AI",
        "TOOLTIP": "Процент на разговорите, разрешени от AI без намеса на оператор"
      },
      "RESOLVE_TIME": {
        "LABEL": "Време за разрешаване",
        "TOOLTIP": "Медианно време от първо съобщение на клиента до последно съобщение на бот/оператор"
      },
      "TOTAL_CONVERSATIONS": {
        "LABEL": "No. of Conversations",
        "TOOLTIP": "Total number of conversations handled by the bot"
      },
      "TOTAL_RESPONSES": {
        "LABEL": "Total Responses",
        "TOOLTIP": "Total number of responses sent by the bot"
      },
      "RESOLUTION_RATE": {
        "LABEL": "Resolution Rate",
        "TOOLTIP": "Total number of conversations resolved by the bot / Total number of conversations handled by the bot * 100"
      },
      "HANDOFF_RATE": {
        "LABEL": "Handoff Rate",
        "TOOLTIP": "Total number of conversations handed off to agents / Total number of conversations handled by the bot * 100"
      }
    },
    "GROUP_BY": {
      "LABEL": "Групирай по",
      "NONE": "Не групирай",
      "INBOXES": "Кутии",
      "LABELS": "Етикети"
    },
    "GROUPED": {
      "CHART_TITLE": "Разпределение по групи",
      "BACK_TO_ALL": "Покажи всички",
      "TABLE": {
        "INBOX": "Кутия",
        "LABEL": "Етикет",
        "CONVERSATIONS": "Разговори",
        "MESSAGES": "Съобщения",
        "MESSAGES_TOOLTIP": "Общ брой изходящи съобщения",
        "AI_MESSAGES": "AI отговори",
        "AI_MESSAGES_TOOLTIP": "Общ брой AI отговори, последван от броя на положителните и отрицателните оценки от крайните потребители",
        "THUMBS_UP_TOOLTIP": "Брой AI отговори, оценени положително (палец нагоре) от крайните потребители",
        "THUMBS_DOWN_TOOLTIP": "Брой AI отговори, оценени отрицателно (палец надолу) от крайните потребители",
        "AI_PERCENTAGE": "AI %",
        "AI_PERCENTAGE_TOOLTIP": "Процент на AI отговорите спрямо всички съобщения в тази група",
        "PREPARED": "Подготвени отговори",
        "PERCENTAGE": "%",
        "PERCENTAGE_TOOLTIP": "Процент на съобщенията от всички съобщения, принадлежащи към тази група",
        "BOT_RESPONSES": "AI отговори %",
        "SUGGESTION_USED": "Използвани отговори",
        "SUGGESTION_USED_TOOLTIP": "Процент на подготвените отговори в тази група, които са били използвани от операторите",
        "SUGGESTION_NOT_USED": "Неизползвани отговори",
        "SUGGESTION_NOT_USED_TOOLTIP": "Процент на съобщенията в тази група, за които е имало подготвен отговор, но не е бил използван"
      },
      "NOTES": {
        "TITLE": "Как се изчисляват метриките",
        "CONVERSATIONS": "Брой на разговорите, които имат поне едно изходящо съобщение в избрания период.",
        "MESSAGES": "Общ брой изходящи (непублични) съобщения, изпратени в избрания период. Това включва както AI-генерирани, така и написани от хора съобщения.",
        "PERCENTAGE": "Дял на съобщенията на тази група от всички изходящи съобщения във всички групи.",
        "AI_MESSAGES": "Брой изходящи съобщения, изпратени автоматично от AI бота (без подготвени отговори за операторите). Числата в скоби показват колко от тези отговори са оценени положително (палец нагоре) и отрицателно (палец надолу) от крайните потребители.",
        "BOT_RESPONSES_PCT": "Дял на AI отговорите на тази група от всички изходящи съобщения в тази група.",
        "PREPARED": "Брой copilot предложения (подготвени отговори), генерирани от AI бота за операторите в избрания период. Това са лични съобщения, видими само за операторите, и не се броят като изходящи съобщения, така че това число може да не корелира с колоната Съобщения.",
        "SUGGESTION_USED": "Процент на подготвените отговори в тази група, които са били използвани от операторите. Това може да не корелира с броя на Подготвени отговори, тъй като може да включва и предложения, генерирани в предишни периоди.",
        "SUGGESTION_NOT_USED": "Процент на изходящите съобщения в тази група, където е имало copilot предложение, но операторът е отговорил без да го използва. Брои се само когато операторът действително е изпратил отговор. Това може да не корелира с броя на Подготвени отговори, тъй като може да включва и предложения, генерирани в предишни периоди."
      }
    }
  },
  "OVERVIEW_REPORTS": {
    "HEADER": "Overview",
    "LIVE": "Live",
    "ACCOUNT_CONVERSATIONS": {
      "HEADER": "Open Conversations",
      "LOADING_MESSAGE": "Loading conversation metrics...",
      "OPEN": "Отворен",
      "UNATTENDED": "Unattended",
      "UNASSIGNED": "Неназначен",
      "PENDING": "Предстоящ"
    },
    "CONVERSATION_HEATMAP": {
      "HEADER": "Conversation Traffic",
      "NO_CONVERSATIONS": "No conversations",
      "CONVERSATION": "{count} conversation",
      "CONVERSATIONS": "{count} conversations",
      "DOWNLOAD_REPORT": "Download report"
    },
    "AGENT_CONVERSATIONS": {
      "HEADER": "Conversations by agents",
      "LOADING_MESSAGE": "Loading agent metrics...",
      "NO_AGENTS": "There are no conversations by agents",
      "TABLE_HEADER": {
        "AGENT": "Агент",
        "OPEN": "Отворен",
        "UNATTENDED": "Unattended",
        "STATUS": "Статус"
      }
    },
    "TEAM_CONVERSATIONS": {
      "ALL_TEAMS": "All Teams",
      "HEADER": "Conversations by teams",
      "LOADING_MESSAGE": "Loading team metrics...",
      "NO_TEAMS": "There is no data available",
      "TABLE_HEADER": {
        "TEAM": "Team",
        "OPEN": "Отворен",
        "UNATTENDED": "Unattended",
        "STATUS": "Статус"
      }
    },
    "AGENT_STATUS": {
      "HEADER": "Agent status",
      "ONLINE": "Online",
      "BUSY": "Busy",
      "OFFLINE": "Offline"
    }
  },
  "DAYS_OF_WEEK": {
    "SUNDAY": "Sunday",
    "MONDAY": "Monday",
    "TUESDAY": "Tuesday",
    "WEDNESDAY": "Wednesday",
    "THURSDAY": "Thursday",
    "FRIDAY": "Friday",
    "SATURDAY": "Saturday"
  },
  "SLA_REPORTS": {
    "HEADER": "SLA Reports",
    "NO_RECORDS": "SLA applied conversations are not available.",
    "LOADING": "Loading SLA data...",
    "DOWNLOAD_SLA_REPORTS": "Download SLA reports",
    "DOWNLOAD_FAILED": "Failed to download SLA Reports",
    "DROPDOWN": {
      "ADD_FIlTER": "Add filter",
      "CLEAR_ALL": "Clear all",
      "CLEAR_FILTER": "Clear filter",
      "EMPTY_LIST": "Няма намерени резултати",
      "NO_FILTER": "No filters available",
      "SEARCH": "Search filter",
      "INPUT_PLACEHOLDER": {
        "SLA": "SLA name",
        "AGENTS": "Agent name",
        "INBOXES": "Inbox name",
        "LABELS": "Label name",
        "TEAMS": "Team name"
      },
      "SLA": "SLA Policy",
      "INBOXES": "Входяща кутия",
      "AGENTS": "Агент",
      "LABELS": "Label",
      "TEAMS": "Team"
    },
    "WITH": "with",
    "METRICS": {
      "HIT_RATE": {
        "LABEL": "Hit Rate",
        "TOOLTIP": "Percentage of SLAs created were completed successfully"
      },
      "NO_OF_MISSES": {
        "LABEL": "Number of Misses",
        "TOOLTIP": "Total SLA misses in a certain period"
      },
      "NO_OF_CONVERSATIONS": {
        "LABEL": "Number of Conversations",
        "TOOLTIP": "Total number of conversations with SLA"
      }
    },
    "TABLE": {
      "HEADER": {
        "POLICY": "Policy",
        "CONVERSATION": "Разговор",
        "AGENT": "Агент"
      },
      "VIEW_DETAILS": "View Details"
    }
  },
  "SUMMARY_REPORTS": {
    "SUBTOTAL": "Междинна сума",
    "NO_TEAM": "Без екип",
    "GROUP_BY_TEAMS": "Групиране по екипи",
    "INBOX": "Входяща кутия",
    "AGENT": "Агент",
    "TEAM": "Team",
    "LABEL": "Етикет",
    "TOTAL": "Total",
    "AVG_RESOLUTION_TIME": "Avg. Resolution Time",
    "AVG_FIRST_RESPONSE_TIME": "Avg. First Response Time",
    "AVG_REPLY_TIME": "Avg. Customer Waiting Time",
    "RESOLUTION_COUNT": "Resolution Count",
    "CONVERSATIONS": "No. of conversations",
    "OUTGOING_CHATS": "Outgoing chats",
    "OUTGOING_EMAILS": "Outgoing emails",
    "PHONE_CALLS": "Phone calls",
    "INBOUND_CALLS": "Inbound calls",
    "OUTBOUND_CALLS": "Outbound calls",
    "TOTAL_ACTIVITIES": "Total activities",
    "ONLINE_TIME": "Online time",
    "QUEUE_AVAILABLE_TIME": "Queue available time",
    "TOOLTIPS": {
      "OUTGOING_CHATS": "Number of outgoing messages sent by this agent",
      "OUTGOING_EMAILS": "Number of outgoing emails sent by this agent",
      "PHONE_CALLS": "Total number of phone calls assigned to this agent (sum of inbound and outbound calls)",
      "TOTAL_ACTIVITIES": "Total number of activities: inbound calls + outbound calls + outgoing chats + outgoing emails",
      "INBOUND_CALLS": "Number of inbound phone calls assigned to this agent",
      "OUTBOUND_CALLS": "Number of outbound phone calls assigned to this agent",
      "AVG_FIRST_RESPONSE_TIME": "Average time from conversation creation to first agent response in conversations assigned to this agent",
      "AVG_RESOLUTION_TIME": "Average time from conversation creation to resolution in conversations assigned to this agent",
      "AVG_REPLY_TIME": "Average time customers wait between their message and agent's reply in conversations assigned to this agent",
      "ONLINE_TIME": "Total time the agent was online or busy during the selected period",
      "QUEUE_AVAILABLE_TIME": "Total time the agent was available in phone queues during the selected period"
    }
  },
  "PHONE_REPORTS": {
    "HEADER": "Phone Reports",
    "DESCRIPTION": "Track phone call metrics with detailed insights on inbound and outbound calls, grouped by agent or inbox for comprehensive analysis.",
    "AGENT_HEADER": "Phone Reports - By Agent",
    "INBOX_HEADER": "Phone Reports - By Inbox",
    "DOWNLOAD_BUTTON": "Download Phone Reports",
    "DOWNLOAD_PHONE_REPORTS": "Download Phone Reports",
    "GROUP_BY": {
      "LABEL": "Group By",
      "AGENT": "Agent",
      "INBOX": "Inbox"
    },
    "TABLE": {
      "AGENT_NAME": "Agent Name",
      "INBOX_NAME": "Inbox Name",
      "TOTAL_CALLS": "Total",
      "INBOUND_CALLS": "Inbound",
      "OUTBOUND_CALLS": "Outbound",
      "FAILED_OUTBOUND_CALLS": "Failed outbound",
      "AVG_AGENT_HANDLED_DURATION": "Avg Duration",
      "TOTAL_AGENT_HANDLED_DURATION": "Total Duration",
      "AVG_RINGING_TIME": "Avg Ring Time",
      "CONNECTED_OUTBOUND_PERCENTAGE": "Success %",
      "UNIQUE_CALLERS": "Unique Callers",
      "UNIQUE_CALLED_CONTACTS": "Unique Called",
      "UNANSWERED_MISSED_CALLS": "Missed no followup",
      "UNANSWERED_MISSED_PERCENTAGE": "Unaswered missed %",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_CALLS": "Missed no followup, insufficiently called back",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_PERCENTAGE": "Missed no followup, insufficiently called back %"
    },
    "TOOLTIPS": {
      "TOTAL_CALLS": "Total number of all calls (including unconnected)",
      "INBOUND_CALLS": "Number of connected calls",
      "OUTBOUND_CALLS": "Number of all outbound calls (including unconnected)",
      "FAILED_OUTBOUND_CALLS": "Number of outbound calls that failed to connect",
      "AVG_AGENT_HANDLED_DURATION": "Average duration of calls handled by agents",
      "TOTAL_AGENT_HANDLED_DURATION": "Total duration of all calls handled by agents",
      "AVG_RINGING_TIME": "Average time calls spent ringing before being answered",
      "CONNECTED_OUTBOUND_PERCENTAGE": "Percentage of outbound calls that were successfully connected",
      "UNIQUE_CALLERS": "Number of unique contacts who made inbound calls",
      "UNIQUE_CALLED_CONTACTS": "Number of unique contacts who were called via outbound calls",
      "UNANSWERED_MISSED_CALLS": "Number of missed calls where no successful callback was made (call connected). May include calls that can still be handled within the business day",
      "UNANSWERED_MISSED_PERCENTAGE": "Percentage of unique callers whose calls were missed without followup (unanswered missed calls / unique callers)",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_CALLS": "Number of missed calls with less than 2 callback attempts. May include calls that can still be handled within the business day",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_PERCENTAGE": "Percentage of unique callers with less than 2 callback attempts ((missed no followup - sufficiently handled) / unique callers)"
    },
    "EMPTY_STATE": {
      "TITLE": "No phone call data available",
      "MESSAGE": "There are no phone calls in the selected date range. Try adjusting your filters or date range."
    }
  }
}
